export function getGradientColor(value, leftColor = "#f33030ff", rightColor = "#4ecc42ff") {
  // Clamp value to 0-100 range
  value = Math.max(0, Math.min(100, value));
  const ratio = value / 100;

  // Helper to parse hex and convert to RGBA
  function hexToRgba(hex) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    let a = hex.length === 9 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
    return { r, g, b, a };
  }

  // Interpolate between two values
  function interpolate(start, end, ratio) {
    return Math.round(start + (end - start) * ratio);
  }

  const left = hexToRgba(leftColor);
  const right = hexToRgba(rightColor);

  const r = interpolate(left.r, right.r, ratio);
  const g = interpolate(left.g, right.g, ratio);
  const b = interpolate(left.b, right.b, ratio);
  const a = left.a + (right.a - left.a) * ratio;

  return `rgba(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
}
